"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicTableCellEditor = exports.TableCell = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var constants_1 = __importDefault(require("../../constants"));
var DynamicEditor_1 = require("./DynamicEditor");
var EditorStyles_1 = require("./EditorStyles");
var InputEditor_1 = require("./InputEditor");
var RichTextEditor_1 = require("./RichTextEditor");
var TextAreaEditor_1 = require("./TextAreaEditor");
exports.TableCell = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", "\n\t", "\n\t", "\n\n\t.tws-rte-wrapper {\n\t\tbackground-color: unset;\n\t\tborder: none;\n\t\tborder-radius: 0;\n\t\tbox-shadow: none;\n\t\t-webkit-box-shadow: none;\n\n\t\t.tws-rte-toolbar {\n\t\t\t", "\n\t\t}\n\t\t.tws-rte-editor {\n\t\t\t", "\n\t\t\t", "\n\t\t}\n\t}\n"], ["\n\t", "\n\t", "\n\t", "\n\n\t.tws-rte-wrapper {\n\t\tbackground-color: unset;\n\t\tborder: none;\n\t\tborder-radius: 0;\n\t\tbox-shadow: none;\n\t\t-webkit-box-shadow: none;\n\n\t\t.tws-rte-toolbar {\n\t\t\t", "\n\t\t}\n\t\t.tws-rte-editor {\n\t\t\t", "\n\t\t\t", "\n\t\t}\n\t}\n"])), function (props) { return (props.width ? "width: ".concat(props.width, ";") : ''); }, function (props) { return (props.minWidth ? "min-width: ".concat(props.minWidth, ";") : ''); }, function (props) { return (props.maxWidth ? "max-width: ".concat(props.maxWidth, "; ") : ''); }, EditorStyles_1.ToolBarStyle, function (props) { return (0, EditorStyles_1.EditorStyle)(props.minHeight, props.maxHeight); }, function (props) {
    return props.inputType === 'input'
        ? "\n\t\t\t\tmin-height: 0;\n\t\t\t\tmax-height: 54px;\n\t\t\t\toverflow-y: hidden;\n\n\t\t\t\t.public-DraftEditor-content, .public-DraftStyleDefault-block {\n\t\t\t\t\tpadding-bottom: 3px;\n\t\t\t\t}\n\t\t\t\t.public-DraftStyleDefault-block span {\n\t\t\t\t\twhite-space: nowrap!important;\n\t\t\t\t}"
        : '';
});
exports.TableCell.displayName = 'TableCell';
var DynamicTableCellEditor = /** @class */ (function (_super) {
    __extends(DynamicTableCellEditor, _super);
    function DynamicTableCellEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toolbarConfiguration = _this.props.toolbarConfiguration
            ? __assign({}, _this.props.toolbarConfiguration) : __assign({}, constants_1.default.EDITOR_DEFAULT_MODE);
        return _this;
    }
    DynamicTableCellEditor.prototype.render = function () {
        var enableHtmlEditor = this.props.enableHtmlEditor;
        return React.createElement(React.Fragment, null, enableHtmlEditor ? this.getRichTextEditor() : this.getSimpleEditor());
    };
    DynamicTableCellEditor.prototype.getRichTextEditor = function () {
        var _a = this.props, inputType = _a.inputType, htmlEditorMode = _a.htmlEditorMode, minHeight = _a.minHeight, maxHeight = _a.maxHeight, minWidth = _a.minWidth, maxWidth = _a.maxWidth, value = _a.value, width = _a.width, rest = __rest(_a, ["inputType", "htmlEditorMode", "minHeight", "maxHeight", "minWidth", "maxWidth", "value", "width"]);
        return (React.createElement(exports.TableCell, { inputType: inputType, width: width, minHeight: minHeight, maxHeight: maxHeight, minWidth: minWidth, maxWidth: maxWidth },
            React.createElement(RichTextEditor_1.RichTextEditor, __assign({}, rest, { mode: htmlEditorMode, inputType: inputType, value: value, toolbar: htmlEditorMode === 'custom'
                    ? this.toolbarConfiguration
                    : htmlEditorMode === 'full'
                        ? constants_1.default.EDITOR_FULL_MODE
                        : constants_1.default.EDITOR_DEFAULT_MODE, onBlur: this.onBlur, onChange: this.onEditorChange }))));
    };
    // The SimpleEditor getter operates on a switch in order to force the implementation of the DTE to be more
    // specific about which input type is in use. If the input type is not specified, it displays a message.
    DynamicTableCellEditor.prototype.getSimpleEditor = function () {
        var _a = this.props, deleted = _a.deleted, inputType = _a.inputType, id = _a.id, maxLength = _a.maxLength, onPaste = _a.onPaste, placeholder = _a.placeholder, readOnly = _a.readOnly, value = _a.value;
        switch (inputType) {
            case 'textarea':
                return (React.createElement(TextAreaEditor_1.TextArea, { id: id, className: 'tws-editable-textarea', deleted: deleted ? deleted.toString() : '', disabled: readOnly, maxLength: maxLength, onChange: this.onChange, onBlur: this.onBlur, onPaste: function (e) { return (onPaste ? onPaste(e.clipboardData.getData('Text'), e) : null); }, placeholder: placeholder, value: value || '' }));
            case 'input':
                return (React.createElement(InputEditor_1.Input, { id: id, value: value || '', onChange: this.onChange, onBlur: this.onBlur, onPaste: function (e) { return (onPaste ? onPaste(e.clipboardData.getData('Text'), e) : null); }, placeholder: placeholder, disabled: readOnly, maxLength: maxLength }));
            case 'typeahead':
            default:
                return React.createElement("span", null,
                    "The editable type '",
                    inputType,
                    "' is not supported in the DynamicTableCellEditor.");
        }
    };
    return DynamicTableCellEditor;
}(DynamicEditor_1.DynamicEditor));
exports.DynamicTableCellEditor = DynamicTableCellEditor;
var templateObject_1;
